var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubricsStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_41",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3077 0H0V70H67.3077V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7676 0.5H43.2383C45.6968 0.500208 47.7796 2.08237 48.5645 4.28516L48.6826 4.61719H65.3848V36.5586H62.2676V7.73535H48.9141V15.9707H21.0908V7.73535H7.7373V66.3828H34.5029V69.5H4.62012V4.61719H21.3223L21.4404 4.28516C22.2255 2.08219 24.3089 0.5 26.7676 0.5ZM40.334 54.0293V57.1475H33.4443V54.0293H40.334ZM28.3271 45.7939V57.1475H16.9736V45.7939H28.3271ZM20.0918 54.0293H25.209V48.9121H20.0918V54.0293ZM42.7383 45.7939V48.9121H33.4443V45.7939H42.7383ZM44.7979 33.4414V36.5586H33.4443V33.4414H44.7979ZM28.3271 25.2061V36.5586H16.9736V25.2061H28.3271ZM20.0918 33.4414H25.209V28.3232H20.0918V33.4414ZM53.0332 25.2061V28.3232H33.4443V25.2061H53.0332ZM26.7676 3.61719C25.3549 3.61719 24.208 4.7642 24.208 6.17676V12.8525H45.7969V6.17676C45.7969 4.76433 44.6507 3.61745 43.2383 3.61719H26.7676Z",
    stroke: "#1D99C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7412 40.2656C56.788 40.2656 58.4481 41.9249 58.4482 43.9717C58.4482 46.0186 56.7881 47.6787 54.7412 47.6787C52.6945 47.6785 51.0352 46.0185 51.0352 43.9717C51.0353 41.925 52.6946 40.2658 54.7412 40.2656Z",
    stroke: "#1D99C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6567 55.165C56.6353 55.165 58.5945 55.5544 60.4224 56.3115V56.3125C62.1362 57.0223 63.7034 58.0417 65.0454 59.3193L65.311 59.5781C66.71 60.977 67.8195 62.638 68.5767 64.4658C68.9779 65.4343 69.2757 66.4402 69.4673 67.4658C69.6294 68.3341 68.9058 69.2324 67.7573 69.2324H41.5562C40.4077 69.2324 39.6841 68.3341 39.8462 67.4658C40.0377 66.4403 40.3356 65.4344 40.7368 64.4658C41.4466 62.7523 42.4663 61.1855 43.7437 59.8438L44.0024 59.5781C45.4015 58.179 47.0631 57.0696 48.8911 56.3125V56.3115C50.719 55.5544 52.6783 55.165 54.6567 55.165Z",
    stroke: "#1D99C6",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubricsStudentIcon);
export default __webpack_public_path__ + "static/media/RubricsStudentIcon.5fdc38764a66de47fa6e8bb3e08a647d.svg";
export { ForwardRef as ReactComponent };